export default __webpack_public_path__ + "static/media/iconPhp.00baeb44.png";